import { ConnectionsPanel } from "@/features/api-tokens/connections-panel";

// /admin/settings/connections — internal API access & MCP tokens. Renders the
// shared ConnectionsPanel against the /settings/tokens mount, so an internal
// PAT carries the issuer's internal role + permissions into MCP tool calls.
export function AdminConnectionsPage() {
  return (
    <div className="max-w-3xl">
      <header className="mb-7">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Admin
        </p>
        <h1 className="mt-1 font-display text-3xl font-semibold tracking-tight">
          Connections
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          Connect AI clients to Colab over the Model Context Protocol.
        </p>
      </header>

      <ConnectionsPanel scope="settings" />
    </div>
  );
}
